import * as React from "react";
import { SVGProps } from "react";
export function ChevronFillDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m5 5.5 5-5H0l5 5Z" fill="currentColor" />
    </svg>
  );
}
